export const siteStyles = {
  //day mode
  0: {
    primary: 'rgba(64, 1, 30, 1)',
    hover: 'rgba(64, 1, 30, 0.2)',
    highlight: 'underline',
    background:'rgba(251, 226, 161, 1)',
    rightRadial: 'radial-gradient(circle, rgba(176,241,76,0.8) 0%, rgba(176,241,76,0.6) 60%, rgba(176,241,76,0) 80%)',
    rightShadow: '0px 0px 20px 20px rgba(176,241,76,0.2)',
    leftRadial: 'radial-gradient(circle, rgba(226,97,56,0.8) 0%, rgba(226,97,56,0.6) 60%, rgba(226,97,56,0) 80%)',
    leftShadow: '0px 0px 20px 20px rgba(226,97,56,0.2)',
    border: '3px solid rgba(64, 1, 30, 1)',
  },
  //night mode
  1: {
    primary: 'rgba(245, 187, 65, 1)',
    hover: 'rgba(245, 187, 65, 0.2)',
    highlight: 'underline',
    background:'rgba(1, 6, 51, 1)',
    rightRadial: 'radial-gradient(circle, rgba(78,179,249,0.8) 0%, rgba(78,179,249,0.6) 60%, rgba(78,179,249,0) 80%)',
    rightShadow: '0px 0px 20px 20px rgba(78,179,249,0.35)',
    leftRadial: 'radial-gradient(circle, rgba(255,0,119,0.8) 0%, rgba(255,0,119,0.6) 60%, rgba(255,0,119,0) 80%)',
    leftShadow: '0px 0px 20px 20px rgba(255,0,119,0.35)',
    border: '3px solid rgba(245, 187, 65, 1)',
  }
}